/** Full-width interaction target for column resize gutters (px). */
export const COLUMN_GUTTER_WIDTH_PX = 16;
